<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMail_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.661 8.446a2.501 2.501 0 0 1-3.323 0L1.297 3.964A1.992 1.992 0 0 1 3 3h10a1.99 1.99 0 0 1 1.702.963L9.661 8.446ZM15 11c0 .343-.094.66-.246.942l-3.336-3.72L15 5.037V11ZM1 5.037V11c0 .343.094.66.246.942l3.336-3.72L1 5.037Zm9.326 4.157.345-.307 3.404 3.795A1.989 1.989 0 0 1 13 13H3c-.396 0-.764-.119-1.075-.317l3.404-3.796.345.306A3.49 3.49 0 0 0 8 10.078c.832 0 1.663-.295 2.326-.884Z"
        clip-rule="evenodd"
    />
</svg>
